<template>
  <div class="page-container-wrapper">
    <loader v-if="dataLoading"/>
    <template v-else>
      <template>
        <div class="page-container-header d-flex align-items-center">
          <h2 class="text-md mb-0">{{ $t('message.Guideline.publications') }}</h2>

          <template v-if="actionButtons && isGpc">
            <b-button variant="danger" class="ml-auto mr-2" @click="showRejectForm">{{ $t("message.Guideline.reject") }}</b-button>
            <b-button variant="success" class="mr-2" @click="showApproveInfo">{{ $t("message.Guideline.preApproved") }}</b-button>
            <b-button variant="warning" @click="showAWNInfo">{{ $t("message.Guideline.additionalWorkNeeded") }}</b-button>
            <b-button variant="info" class="mr-2 ml-2" @click="$router.push('/guidelines/')">{{ $t('message.return') }}</b-button>
          </template>
          <b-button v-else variant="info" class="mr-2 ml-auto" @click="goBack">{{ $t('message.return') }}</b-button>
        </div>

        <div class="container-fluid">
          <div class="row">
            <!-- LEFT -->
            <div class="col-md-12 col-xl-7">
              <div class="page-container guidelines-editor" id="page-container">
                <div class="padding">

                  <div v-if="showCoiNotAcceptedInfo" class="row">
                    <div class="col-md-12">
                      <b-alert show variant="danger">{{ $t('message.Guideline.coiNotAcceptedInfo') }}</b-alert>

                      <b-table striped hover :items="guideline.coi_users" :fields="['name', 'email', 'conflict_of_interest']">
                        <template slot="conflict_of_interest" slot-scope="data">
                          <template v-if="data.item.conflict_of_interest">
                            {{ $t('message.Guideline.coiAccepted') }}
                          </template>
                          <template v-else>
                            {{ $t('message.Guideline.coiNotAccepted') }}
                          </template>
                        </template>
                      </b-table>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <!-- LEFT BASE DATA -->
                      <base-data-left :guideline="guideline" class="d-xl-none"></base-data-left>

                      <!-- LEFT PROGRESS -->
                      <phase-preview-left :guideline="guideline" class="d-xl-none"></phase-preview-left>

                      <template v-if="!showCoiNotAcceptedInfo">
                        <!-- THIS PART IS HIDDEN FOR PURPOSE ;P THIS IS SECTION WITH FILES
                          <b-card v-if="filesUploaded && filesUploaded.length > 0" :title="$t('message.Guideline.sectionFilesUploaded')" class="mb-2 fileUploader">
                            <b-table striped hover :items="filesUploaded" :fields="[ 'user_name', 'upload_id', 'size', 'name', 'type', 'actions']">
                              <template slot="info" slot-scope="data">
                                <pre>
                                  {{ data.item.response.data.id  }}
                                </pre>
                              </template>

                              <template slot="upload_id" slot-scope="data">
                                {{ $t("message.Guideline.fileVersion", {version: data.item.upload_id}) }}
                              </template>

                              <template slot="actions" slot-scope="data">
                                <a target="_blank" :href="getFileUrl(data.item)">
                                  <font-awesome-icon icon="download" size="lg" class="mr-2"/>
                                </a>
                              </template>
                            </b-table>
                          </b-card>
                        -->

                        <b-card :title="$t('message.Guideline.sectionFileUpload')" class="mb-2 fileUploader">

                          <div class="dropzone mb-4" v-show="$refs.upload && $refs.upload.drop">
                            <div :class="{ 'dragActive' : $refs.upload && $refs.upload.dropActive }">
                              <h5 v-html="$t('message.Guideline.draganddrop')"></h5>
                              <label for="gl" class="btn btn-primary">{{ $t('message.Guideline.selectFiles') }}</label>
                              <br><br>
                              <h5 style="color: red" v-html="$t('message.Guideline.draganddropUnderButtonSubmitter')"></h5>
                            </div>
                          </div>

                          <template v-if="filesToUpload && filesToUpload.length">
                            <div class="table-responsive">
                              <b-table striped hover :items="filesToUpload" :fields="['size', 'name', 'type', 'progress', 'actions']">
                                <template slot="info" slot-scope="data">
                              <pre>
                                {{ data.item.response.data.id }}
                              </pre>
                                </template>

                                <template slot="progress" slot-scope="data">
                                  <b-progress :value="parseInt(data.item.progress)" :max="100" show-progress animated></b-progress>
                                </template>

                                <template slot="actions" slot-scope="data">
                                  <a target="_blank" :href="getFileUrl(data.item)">
                                    <font-awesome-icon icon="download" size="lg" class="mr-2"/>
                                  </a>

                                  <a @click.prevent="deleteFileInfo(data.item, data.index)">
                                    <font-awesome-icon icon="trash" size="lg" class="mr-2 text-danger"/>
                                  </a>
                                </template>
                              </b-table>
                            </div>
                          </template>

                          <b-form-checkbox id="proceduresStandards"
                                           v-model="proceduresStandards"
                                           :value=true
                                           :unchecked-value=false
                          >

                            <var class="text-danger">*</var>
                            {{ $t('message.Guideline.proceduresStandardsText') }}
                            <a href="/pdf/2026_EANM_GL_Standard_Texts_v2.pdf" target="_blank">
                              {{ $t('message.Guideline.proceduresStandardsLink') }}
                            </a>
                            {{ $t('message.Guideline.proceduresStandardsIncluded') }}
                          </b-form-checkbox>

                          <b-button :disabled="(filesToUpload && filesToUpload.length === 0) || ($refs.upload && $refs.upload.active) || !proceduresStandards" variant="success"
                                    class="float-right mr-2" @click="uploadGuidelineInfo">{{ uploadButtonText }}
                          </b-button>

                          <file-upload
                              ref="upload"
                              v-model="filesToUpload"
                              :post-action="uploadUrl"
                              name="gl"
                              :headers="{'Authorization': 'Bearer ' + getAuthToken}"
                              chunk-enabled
                              :chunk="chunk"
                              :drop="true"
                              @input-filter="inputFilter"
                              @input="$refs.upload.active = true"
                              :multiple="true"
                          >
                          </file-upload>
                        </b-card>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- RIGHT -->
            <div class="d-md-none d-xl-block col-xl-5">
              <base-data-right :guideline="guideline"></base-data-right>

              <phase-preview :guideline="guideline"></phase-preview>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {GUIDELINE_REQUEST_BY_ID, GUIDELINE_DELETE_FILE_BY_ID, GUIDELINE_CHANGE_PHASE} from '@/store/actions/guidelines';
import {Guideline, GuidelinePhases} from '@/lib/guideline.js';

import FileUpload from 'vue-upload-component/dist/vue-upload-component.part.js'

import BaseDataRight from '@/components/Guideline/BaseData/right.vue'
import BaseDataLeft from '@/components/Guideline/BaseData/left.vue'

import PhasePreview from '@/components/Guideline/PhasePreview'
import PhasePreviewLeft from '@/components/Guideline/PhasePreview/left.vue'

export default {
  name: 'guideline-upload',
  components: {
    FileUpload,
    BaseDataRight,
    BaseDataLeft,
    PhasePreview,
    PhasePreviewLeft
  },
  props: [],
  data() {
    return {
      guideline: new Guideline,
      guidelinePhases: GuidelinePhases,

      filesToUpload: [],
      filesCount: 0,
      proceduresStandards: false,
    }
  },
  computed: {
    actionButtons() {
      return this.guideline.phase !== this.guidelinePhases.rejected &&
          this.guideline.phase !== this.guidelinePhases.preApproved &&
          this.guideline.phase !== this.guidelinePhases.formalCheckApproval;
    },

    chunk() {
      return {
        headers: {'Authorization': 'Bearer ' + this.getAuthToken},
        action: this.uploadChunkedUrl,
        maxActive: 1,
        maxRetries: 5
      }
    },

    filesUploaded() {
      if (this.guideline && this.guideline.files) {
        return this.guideline.files.filter(elem => {
          return elem.upload_id != null && elem.user_id === this.guideline.submitter_id;
        });
      }

      return [];
    },

    uploadButtonText() {
      switch (this.guideline.phase) {
        case this.guidelinePhases.preApproved:
          return this.$t('message.Guideline.startFirstDraft');
      default:
        return this.$t('message.Guideline.startUpload');
      }
    },

    showReviewSection() {
      return this.guideline.upload_id > 0 && this.guideline.reviews.length > 0;
    },

    showCoiNotAcceptedInfo() {
      return !this.guideline.coi_accepted;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    isGuidelineSubmitter() {
      return this.getUserData.id === this.guideline.submitter_id;
    },

    getData() {
      this.$store.dispatch(GUIDELINE_REQUEST_BY_ID, this.$route.params.id).then((response) => {
        let allowedPhases = [
          this.guidelinePhases.preApproved,
          this.guidelinePhases.uploadReviewed,
          this.guidelinePhases.parallelReviewed,
          this.guidelinePhases.uploadGpcReviewed,
          this.guidelinePhases.reviewedByNationalDelegates,
          this.guidelinePhases.gpcFinalHold,
          this.guidelinePhases.boardApprovalOnHold,
        ];

        /**
         * Redirect if phase other that allowed
         */
        if ((allowedPhases.indexOf(response.data.data.phase)) === -1) {
          this.$router.push('/guidelines/' + response.data.data.id + '/review')
        }

        this.guideline = response.data.data;
        this.filesToUpload = this.guideline.files.filter(elem => {
          return elem.upload_id == null;
        });
      }).catch((error) => {
        this.handleUnauth(error.response.status);
      });
    },

    goBack() {
      this.$router.push('/guidelines/')
    },

    uploadGuidelineInfo() {
      let htmlMessage = this.$t('message.Guideline.uploadGuidelineInfo');

      if (this.guideline.phase === this.guidelinePhases.gpcFinalHold) {
        htmlMessage = this.$t('message.Guideline.gpcFinalHoldInfo');
      } else {
        htmlMessage = this.$t('message.Guideline.uploadGuidelineInfo');
      }

      this.$swal({
        title: this.$t('message.areYouSure'),
        html: htmlMessage,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value !== undefined) {
          this.closeUploadPhase();
        }
      });
    },

    closeUploadPhase() {
      let phase = this.guidelinePhases.uploadedForGpcReview;
      let urlAction = '/gpc-review';

      if (this.guideline.phase === this.guidelinePhases.uploadReviewed) {
        phase = this.guidelinePhases.uploadGpcReviewedEnd;
        urlAction = '/review';
      }

      if (this.guideline.phase === this.guidelinePhases.reviewedByNationalDelegates) {
        phase = this.guidelinePhases.reviewByNationalDelegates;
        urlAction = '/nd-review';
      }

      if (this.guideline.phase === this.guidelinePhases.parallelReviewed) {
        phase = this.guidelinePhases.parallelReviewEnd;
        urlAction = '/view';
      }

      if (this.guideline.phase === this.guidelinePhases.gpcFinalHold) {
        phase = this.guidelinePhases.gpcFinalApproval;
        urlAction = '/view';
      }

      if (this.guideline.phase === this.guidelinePhases.boardApprovalOnHold) {
        phase = this.guidelinePhases.boardApproval;
        urlAction = '/view';
      }

      this.$store.dispatch(GUIDELINE_CHANGE_PHASE, {id: this.guideline.id, phase: phase})
          .then(() => {
            let message = this.$t("message.Guideline.successfullyUploaded");

            if (phase === this.guidelinePhases.uploadGpcReviewedEnd || phase === this.guidelinePhases.uploadedForGpcReview) {
              message = this.$t("message.Guideline.successfullyReUploaded");
            }

            if (this.guideline.phase === this.guidelinePhases.preApproved && phase === this.guidelinePhases.uploadedForGpcReview) {
              message = this.$t("message.Guideline.successfullyFirstUpload");
            }

            this.$swal({
              title: this.$t("message.success"),
              text: message,
              type: 'success',
              confirmButtonText: 'OK'
            });

            this.$router.push('/guidelines/' + this.guideline.id + urlAction)
          }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    deleteFileInfo(file, fileIndex) {
      let fileId = file.response != undefined ? file.response.data.id : file.id;

      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.deleteFileInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.deleteFile(fileId, fileIndex);
        }
      });
    },

    deleteFile(fileId) {
      this.$store.dispatch(GUIDELINE_DELETE_FILE_BY_ID, {gid: this.guideline.id, fid: fileId})
          .then(() => {
            this.getData();
          }).catch((error) => {
        this.handleForbidden(error.response.status);
        this.handleUnauth(error.response.status);
      });
    },

    getFileUrl(file) {
      return (file.response && file.response.data != undefined) ? file.response.data.url : (file.url != undefined ? file.url : null);
    },

    getUserFiles(userId, uploadId) {
      return this.guideline.files.filter(elem => {
        return elem.user_id == userId && elem.upload_id == uploadId
      });
    }
  },
  watch: {
    'guideline': function () {
      if (!this.isGuidelineSubmitter()) {
        this.handleForbidden(403);
        this.$router.back();
      }
    }
  }
}
</script>

<style lang="scss">
.guidelines-view {
}

.dragActive {
  background: white;
}

.dropzone {
  background: #e6e6e6;
  text-align: center;
  padding: 30px;
  border: 2px dashed;

  div {
    padding: 20px;
  }
}

.col-form-label {
  text-align: left;
}

.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}

.file-uploads.file-uploads-html4 {
  input[type="file"] {
    opacity: 0;
    font-size: 20em;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.file-uploads.file-uploads-html5 {
  input[type="file"] {
    overflow: hidden;
    position: fixed;
    width: 1px;
    height: 1px;
    z-index: -1;
    opacity: 0;
  }
}
</style>
